import { LoadingOutlined } from "@ant-design/icons";
import React from "react";
const loaderStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  fontSize: "60px",
  color: "#2A71D4",
};
const loader = (props) => {
  const { style, rest } = props;
  const newStyle = { ...loaderStyle, ...style };
  return <LoadingOutlined style={newStyle} {...rest} />;
};

export default loader;
